<template>
  <div :class="isAuthorized ? 'checkout-authorized-headline': ''" class="headline-sm">פרטי לקוח</div>
  <div v-if="!isAuthorized" class="checkout-personal__terms" @click="openLoginModal">
    לקוח רשום?
    <span class="text-link">התחברות</span>
  </div>
  <form action="">
    <div class="errors-checkout-modal">
      <div class="errors-checkout-modal__icon">
        <svg height="32" style="overflow:visible;enable-background:new 0 0 32 32" viewBox="0 0 32 32" width="32"
             xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><g id="Error_1_"><g id="Error"><circle cx="16" cy="16" id="BG" r="16" style="fill:#D72828;"/><path
          d="M14.5,25h3v-3h-3V25z M14.5,6v13h3V6H14.5z" id="Exclamatory_x5F_Sign"
          style="fill:#E6E6E6;"/></g></g></g></svg>
      </div>
      <div class="text-checkout-error" style="text-align: center;">
        לא הושלמו שדות חובה
      </div>
    </div>

    <div class="form-inline">
      <div class="floating-input-wrapper">
        <input v-model="checkout.personal_info.first_name" type="text" name="first_name" class="floating-input"
               required>
        <span v-bind:class="getErrors()['personal_info.first_name'] ? 'label-error floating-label' : 'floating-label'">
                    שם פרטי
                    <span class="required-star">*</span>
                </span>
      </div>
      <div class="floating-input-wrapper">
        <input v-model="checkout.personal_info.last_name" type="text" name="last_name" class="floating-input" required>
        <span v-bind:class="getErrors()['personal_info.last_name'] ? 'label-error floating-label' : 'floating-label'">
                    שם משפחה
                    <span class="required-star">*</span>
                </span>
      </div>
    </div>
    <div class="form-inline">
      <div class="floating-input-wrapper">
        <input v-model="checkout.personal_info.phone" type="text" name="phone" class="floating-input" required>
        <span v-bind:class="getErrors()['personal_info.phone'] ? 'label-error floating-label' : 'floating-label'">
                    טלפון
                    <span class="required-star">*</span>
                </span>
      </div>
      <div class="floating-input-wrapper">
        <input v-model="checkout.personal_info.email" type="text" name="email" class="floating-input" required>
        <span v-bind:class="getErrors()['personal_info.email'] ? 'label-error floating-label' : 'floating-label'">
                    דוא"ל
                    <span class="required-star">*</span>
                </span>
      </div>
    </div>
    <div v-if="!isAuthorized" class="form-check">
      <input v-model="checkout.personal_info.authenticate" type="checkbox" id="registerCustomer" value="1"/>
      <label for="registerCustomer">הרשמה לאתר</label>
    </div>
    <div style="visibility: hidden; height: 0; margin: 0;" class="ctb"
         v-if="!isAuthorized && checkout.personal_info.authenticate">
      <div class="ctb__title">
        סוג לקוח:
      </div>
      <div class="ctb__items">
        <div v-for="ct in ctb" :key="`ct${ct.id}`"
             class="ctb__item"
             :class="{active: ct.id === checkout.personal_info.customer_type_id}"
             @click="checkout.personal_info.customer_type_id = ct.id"
        >
          <img :src="ct.img" alt="">
          <span>
            {{ ct.text }}
          </span>
        </div>
      </div>
    </div>
    <div class="form-inline" v-if="!isAuthorized && checkout.personal_info.authenticate">
      <div class="floating-input-wrapper">
        <input v-model="checkout.personal_info.password" type="password" name="password" class="floating-input"
               required>
        <span v-bind:class="getErrors()['personal_info.password'] ? 'label-error floating-label' : 'floating-label'">
                    סיסמה
                    <span class="required-star">*</span>
                </span>
      </div>

      <div class="floating-input-wrapper">
        <input v-model="checkout.personal_info.password_confirmation" type="password" name="password"
               class="floating-input" required>
        <span
          v-bind:class="getErrors()['personal_info.password_confirmation'] ? 'label-error floating-label' : 'floating-label'">
                    אימות סיסמה
                    <span class="required-star">*</span>
                </span>
      </div>
    </div>

    <div style="visibility: hidden; height: 0; margin: 0;" class="form-check">
      <input v-model="checkout.newsletter" type="checkbox" id="newsletter" value="1"/>
      <label for="newsletter">אני מעוניין לקבל הצעות והנחות מיוחדות בדוא"ל</label>
    </div>

    <textarea v-model="checkout.comment" placeholder="הערות להזמנה"></textarea>
  </form>
</template>

<style lang="scss" scoped>
@media (max-width: 480px) {
  .checkout-personal {
   .floating-label {
      top: 5px;
    }
    .form-inline {
      flex-wrap: wrap;
      .floating-input-wrapper {
        width: 100%;
        input {
          width: 100%;
          height: 50px;
          padding-bottom: 5px;
          font-size: 14px;
        }
      }
    }
  }
}
</style>

<script>
export default {
  inject: ['getErrors'],
  name: "CheckoutPersonal",
  props: {
    checkout: Object,
  },
  computed: {
    isAuthorized() {
      return !!window.userAuth;
    }
  },
  data() {
    return {
      registerUser: false,
      ctb: [
        {
          id: 3,
          img: '/client/img/cust/t1.svg',
          text: 'מאמן',
        },
        {
          id: 2,
          img: '/client/img/cust/t2.svg',
          text: 'שחקן',
        },
        {
          id: 1,
          img: '/client/img/cust/t3.svg',
          text: 'אחר',
        },
      ],
    }
  },
  mounted() {
  },
  methods: {
    openLoginModal() {
      window.dispatchEvent(new Event('openLoginModal'))
    }
  }
}
</script>

<style scoped>

</style>
